/**
 * @module M/control/ThreeMapeaControl
 */

import ThreeMapeaImplControl from 'impl/threemapeacontrol';
import template from 'templates/threemapea';
import { getValue } from './i18n/language';

export default class ThreeMapeaControl extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor(capas) {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(ThreeMapeaImplControl)) {
      M.exception(getValue('exception.impl'));
    }
    // 2. implementation of this control
    const impl = new ThreeMapeaImplControl(capas);
    super(impl, 'ThreeMapea');
    this.capas = [];
    this.active = false;
  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    this.map_ = map;
    this.updateLayers(map);
    map.getImpl().getMapImpl().getLayers().on('propertychange', () => this.updateLayers(this.map_));
    if (!M.template.compileSync) { // JGL: retrocompatibilidad Mapea4
      M.template.compileSync = (string, options) => {
        let templateCompiled;
        let templateVars = {
          translations: {
            generate_3d_view: getValue('generate_3d_view'),
            magnify: getValue('magnify'),
            mode_3d: getValue('mode_3d'),
            layers: getValue('layers'),
            optimized: getValue('optimized'),
            normal: getValue('normal'),
            middle: getValue('middle'),
            gray: getValue('gray'),
            between: getValue('between'),
            generate_3d: getValue('generate_3d'),
          },
        };

        let parseToHtml;
        if (!M.utils.isUndefined(options)) {
          templateVars = M.utils.extends(templateVars, options.vars);
          parseToHtml = options.parseToHtml;
        }

        const templateFn = Handlebars.compile(string);
        const htmlText = templateFn(templateVars);
        if (parseToHtml !== false) {
          templateCompiled = M.utils.stringToHtml(htmlText);
        } else {
          templateCompiled = htmlText;
        }
        return templateCompiled;
      };
    }

    return new Promise((success, fail) => {
      const html = M.template.compileSync(template, {
        vars: {
          translations: {
            generate_3d_view: getValue('generate_3d_view'),
            magnify: getValue('magnify'),
            mode_3d: getValue('mode_3d'),
            layers: getValue('layers'),
            optimized: getValue('optimized'),
            normal: getValue('normal'),
            middle: getValue('middle'),
            gray: getValue('gray'),
            between: getValue('between'),
            generate_3d: getValue('generate_3d'),
          },
        },
      });

      // Añadir código dependiente del DOM
      this.layers = html.getElementsByTagName('select')[1];
      this.capas.forEach((x) => {
        let opt = document.createElement('option');
        opt.id = 'threemapea-layers';
        opt.appendChild(document.createTextNode(x));
        opt.value = x;
        this.layers.appendChild(opt);
      });
      this.addEvents(html);
      success(html);
    });
  }
  /**
   * This function is called to refresh the layers of the threemapea select
   *
   * @private
   * @function
   * @api stable
   */
  updateLayers(map){
    this.capas = map.getImpl().getMapImpl().getLayers().getArray().filter((x) => {return x.getType() === 'TILE' && x.getSource().params_ !== undefined && x.getSource().getParams().fotograma !== undefined})
      .map((layer) => {
        return layer.getSource().layer_ === undefined
        ? (layer.getSource().getParams().fotograma !== undefined ? `${getValue('photograph')}: ` + layer.getSource().getParams().fotograma :  layer.getSource().getParams().LAYERS)
        : layer.getSource().getLayer()
      });
    
    const buttonGenerate3D = document.getElementById("threeTest");
    const ghostButtonThree = document.getElementById("ghostButtonThree");
    if(buttonGenerate3D !== null){
      if (this.capas.length < 1){
        buttonGenerate3D.disabled = true;
        buttonGenerate3D.style.display = 'none';
        ghostButtonThree.style.display = 'initial';
        ghostButtonThree.onclick = function () {M.dialog.info(getValue("noLayersAvailable"));};
        buttonGenerate3D.title = getValue("noLayersAvailable");
      } else {
        ghostButtonThree.style.display = 'none';
        buttonGenerate3D.style.display = 'initial';
        ghostButtonThree.onclick = function () {return;};
        buttonGenerate3D.disabled = false;
        buttonGenerate3D.title = getValue("generate_3d");
      }
    }
    if(this.getImpl().activated){
      const isDeleted = this.getImpl().checkIfTheLayerIsDeleted();
      if(isDeleted)
        this.deactivate();
    }
    if (this.layers !== undefined) {
      this.selectedLayer = document.getElementById('layers-three').value;
      this.layers.querySelectorAll('*').forEach(n => n.remove());
      this.capas.forEach((x) => {
        const opt = document.createElement('option');
        opt.appendChild(document.createTextNode(x));
        opt.value = x;
        if (this.selectedLayer === x)
          opt.selected = true;
        this.layers.appendChild(opt);
      });
    }
  }

  /**
   * This function is called on the control activation
   *
   * @public
   * @function
   * @api stable
   */
  activate() {
    if (this.capas.length >= 1) {
      // calls super to manage de/activation
      super.activate();
      this.active = true;
      this.moveStartEventKey = this.map_.getMapImpl().on('movestart', () =>this.getImpl().showImgMap());
      this.moveEndEventKey = this.map_.getMapImpl().on('moveend', () => this.getImpl().mapUpdated());
      this.getImpl().activateClick(this.map_);
    } else {
      return;
    }
  }
  /**
   * This function is called on the control deactivation
   *
   * @public
   * @function
   * @api stable
   */
  deactivate() {
    // calls super to manage de/activation
    super.deactivate();
    this.active = false;
    ol.Observable.unByKey(this.moveStartEventKey);
    ol.Observable.unByKey(this.moveEndEventKey);
    this.getImpl().deactivateClick(this.map_);
  }

  /**
   * This function adds event listeners.
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  addEvents(html) {
    this.element_ = html;

    this.magnification = this.element_.querySelector('div.three-col-1 > input');

    this.anaglyphType = this.element_.querySelector('div.three-col-2 > select');

    this.selectLayer = this.element_.querySelector('div.three-col-3 > select');

    this.selectLayer.addEventListener('change', (e) => {
      if (this.active)
        this.getImpl().activateClick(this.map_);
    });

    this.anaglyphType.addEventListener('change', (e) => {
      if (this.active)
        this.getImpl().activateClick(this.map_);
    });

    this.magnification.addEventListener('change', (e) => {
      if (this.active)
        this.getImpl().activateClick(this.map_);
    });

  }



  /**
   * This function gets activation button
   *
   * @public
   * @function
   * @param {HTML} html of control
   * @api stable
   */
  getActivationButton(html) {
    return html.querySelector('.m-threemapea button');
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof ThreeMapeaControl;
  }

  // Add your own functions
}
